module.exports = __webpack_public_path__ + "img/03Icon.d8f23c1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/03Icon.png
// module id = wxFM
// module chunks = 0